<template>
  <v-card :class="[$root.isRTL ? 'fullContentRTL' : 'fullContent']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">equalizer</i>
        {{$t('reports')}}
      </v-toolbar-title>
      <span class="custom-dropdown custom-dropdown--white" style="float: right;">
        <select v-model="selectedReport" class="custom-dropdown__select custom-dropdown__select--white">
          <option value="">בחר דוח</option>
          <option v-for="rpt in reports" :value="rpt">{{rpt}}</option>
        </select>
      </span>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-toolbar>
    <ReportProjects v-if="rptProjects"></ReportProjects>
    <ReportCustomers v-if="rptCustomers"></ReportCustomers>
    <ReportDiaries v-if="rptDiaries"></ReportDiaries>
</v-card>
</template>

<script>

  import ReportProjects from '../components/ReportProjects';
  import ReportCustomers from '../components/ReportCustomers';
  import ReportDiaries from '../components/ReportDiaries';

  export default {
    name: 'Reports',
    components: { ReportProjects, ReportCustomers, ReportDiaries },
    data() {
      return {
        txtSearch: '',
        selectedReport: '',
        reports: ['דוח פרויקטים', 'דוח לקוחות'],
        //reports: ['דוח פרויקטים', 'דוח לקוחות', 'דוח יומנים']
      }
    },
    created() {
      this.$Log("Vue [Reports] is created ...");
    },
    ready() {
      this.$Log("Vue [Reports] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Reports] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Reports] is updated ...");
    },
    computed: {
      rptProjects() {
        return this.selectedReport == 'דוח פרויקטים';
      },
      rptCustomers() {
        return this.selectedReport == 'דוח לקוחות';
      },
      rptDiaries() {
        return this.selectedReport == 'דוח יומנים';
      },
    },
    methods: {
    }
  }

</script>
<style scoped>
  .RTL {
    text-align: right;
  }

    .RTL > tr > td {
      text-align: right;
    }

  .iconArrow2RTL {
    left: -220px;
  }

  .toolbar__title i {
    color: #fff;
    font-size: 30px;
  }

  .toolbar .toolbar__content {
    width: 100% !important;
  }


  .lblTop {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: left;
  }

  .lblTopRTL {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: right;
  }

  .smallRemove {
    float: right;
    padding-left: 10px;
    padding-top: 5px;
    cursor: pointer;
  }

  .btnSend {
    height: 35px;
  }

  .tabs__items {
  }

  .tabs__item {
    text-transform: none !important;
    background-color: #f2f2f2;
    color: #02589B !important;
    border-bottom: 2px solid #02589B;
    padding: 0px 10px !important;
  }

  .divOr {
    color: #02589B;
    text-align: center;
    width: 100%;
  }

  .noData {
    padding: 30px;
    width: 100%;
    text-align: center !important;
    font-size: 20px;
    color: #ccc;
  }

  .cardBlue {
    margin: 0px;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
  }

  .blueTitle {
    width: 96%;
    text-align: left;
  }

  .blueTitleRTL {
    width: 96%;
    text-align: right;
  }

  .blueLink {
    text-align: right;
    font-size: 25px;
    font-weight: lighter;
    color: #fff !important;
    cursor: pointer;
  }

  .lblCommunity {
    font-size: 14px;
    width: 100%;
    text-align: left;
    display: block;
  }

  .lblCommunityRTL {
    font-size: 14px;
    width: 100%;
    text-align: right;
    display: block;
  }

  .imgUser {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }

  .cardBlue .card__title {
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0px;
    background-color: rgb(1, 87, 155);
    height: 40px !important;
    font-size: 13px;
    color: #fff;
  }

  .dialog > .card .card__title {
    padding: 10px;
  }

  .tblUsers {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  table.tblUsers > thead > tr {
    border-bottom: 2px solid #ccc;
  }

    table.tblUsers > thead > tr > td {
      color: #02589B;
      font-weight: bold;
      border-bottom: 2px solid #ccc;
      text-align: left;
      padding-bottom: 10px;
    }

  table.tblUsers > tbody > tr > td {
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
  }

  .avatar {
    text-align: center;
    width: 70px;
  }

  .edit {
    width: 30px;
  }

    .edit > i {
      color: #02589B !important;
      cursor: pointer;
      font-size: 30px;
    }

  .overlay--active {
    z-index: 19000 !important;
  }

  .dialog__content {
    z-index: 20000 !important;
  }

  .input-group__input {
    border: none !important;
  }

  .divTabs {
    width: auto;
    border-bottom: 2px solid #01579B;
    margin: 5px 20px 10px 20px;
  }

  .divTabContent {
    height: 400px;
  }

  .tabTitle {
    color: #999;
    line-height: 40px;
    display: block;
    cursor: pointer;
  }

    .tabTitle:hover {
      color: #02589B;
    }

  .arrow {
    position: relative;
    color: #02589B;
  }

    .arrow:after {
      border: solid transparent;
      content: " ";
      display: block;
      height: 0;
      position: absolute;
      pointer-events: none;
      width: 0;
      top: 100%;
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #02589B;
      left: 50%;
      margin-left: -10px;
      border-width: 10px;
    }

  .divLogo {
    color: #c9c9c9;
    background-color: #e4e4e4;
    width: 60px;
    height: 60px;
    border-radius: 100%;
    line-height: 60px;
    font-size: 20px;
  }

  .iconArrow2 {
    opacity: 1;
    position: relative;
    top: -30px;
    left: 210px;
    color: #999999;
    font-size: 20px;
  }

  .chk {
    padding-top: 5px;
  }

  .chkRTL {
    padding-top: 10px;
    margin-top: 7px;
    margin-left: 5px;
  }

  .chkSpan {
    color: #999999;
    padding-left: 10px;
    font-size: 13px;
  }

  .chkSpanRTL {
    text-align: right;
  }

  .sideLeft {
    float: left;
    padding-left: 10px;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideLeft > i {
      font-size: 20px;
      padding-bottom: 5px;
    }

    .sideLeft > span {
      padding-top: 15px;
      margin-top: 15px;
    }

  .sideRight {
    float: right;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideRight > i {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 4px;
    }

    .sideRight > span {
    }
</style>



// WEBPACK FOOTER //
// Reports.vue?14dd9340